import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Same-origin via ingress → withCredentials sends the httpOnly access_token cookie
// set by the backend. No token is kept in localStorage.
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
